import React from "react";
import { Outlet } from "react-router-dom";

import classNames from "classnames";
import { Container } from "react-bootstrap";

import { store } from "../..";
import { globalActions } from "../../features/global/globalSlice";

export const loader = async () => {
    const { settings, sites, umpires } = store.getState().global;
    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !umpires.length &&
        promises.push(store.dispatch(globalActions.getUmpires()));

    await Promise.all(promises);

    return null;
};

const AdminLayout = (): React.JSX.Element => {
    return (
        <Container
            className={classNames("py-5", "admin")}
            data-testid="adminContent"
        >
            <Outlet />
        </Container>
    );
};

export default AdminLayout;
